<template>
    <div class="provider-wrapper">
        <span>
            {{ provider.type }}
        </span>
        <span class="provider-wrapper__info">
            <span class="provider-wrapper__icon">
                <component :is="`icon-${provider.icon}`" />
            </span>
            {{ provider.label }}
        </span>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
export default {
    components: {
        'icon-envelope': defineAsyncComponent(() => import('vcomponents/icons/IconEnvelope.vue')),
        'icon-google-authenticator': defineAsyncComponent(
            () => import('vcomponents/icons/IconGoogleAuthenticator.vue'),
        ),
        'icon-phone': defineAsyncComponent(() => import('vcomponents/icons/IconPhone.vue')),
    },
    props: {
        provider: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.provider-wrapper {
    align-items: center;
    border: 1px solid $gray-40;
    border-radius: 4px;
    color: $gray-60;
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    margin: 0 0 16px;
    padding: 12px;
    @media only screen and (min-width: 400px) {
        padding: 16px;
    }
    &__info {
        align-items: center;
        color: $gray-100;
        display: flex;
        font-weight: 700;
        margin: 0 0 0 8px;
    }
    &__icon {
        height: 24px;
        margin: 0 8px 0 0;
        width: 24px;
    }
}
</style>
